const StructuredDataMap = {
  DEFAULT: 'LocalBusiness',
  HOSPITALS: 'Hospital',
  DOCTORS: {
    DEFAULT: 'Physician',
    DENTIST: 'Dentist',
  },
}

export default StructuredDataMap
